export default "__VITE_ASSET__ByQx3rwX__"